import React from 'react';
import ThingsToDoResults from './ThingsToDoResults';
import {Alert} from 'app-ui-componentlibrary/dist/componentLibrary/layout';
import {ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {Grid, Loader} from 'semantic-ui-react';
import _ from 'lodash';
import {ISOToDisplayDate, formatDateMMDDYYYY} from 'common/utils';

const ThingsToDoCards = ({thingsToDo, filters, loading, setRedirect, props}) => {
  // thingsToDo should be a mixed array of tasks and entities for the user
  // a thingToDo should have {entityType, status, subrecipientName, dueDate, dataType : {task ||  entity}}
  let filteredThings = [];
  let filterTarget = 0;
  if (_.size(filters.fundingOpportunityName) > 0) filterTarget = filterTarget + 1;
  if (_.size(filters.recipient) > 0) filterTarget = filterTarget + 1;
  if (_.size(filters.subRecipient) > 0) filterTarget = filterTarget + 1;
  if (_.size(filters.disasterType) > 0) filterTarget = filterTarget + 1;
  if (filters.status !== undefined && filters.status !== '')
    filterTarget = filterTarget + 1;
  if (filters.dueDate !== undefined && filters.dueDate !== '')
    filterTarget = filterTarget + 1;
  if (filterTarget === 0) {
    filteredThings = _.cloneDeep(thingsToDo);
  } else {
    _.forEach(thingsToDo, (thingToDo) => {
      let filterTotal = 0;
      if (
        thingToDo.fundingOpportunityId &&
        _.includes(filters.fundingOpportunityName, thingToDo.fundingOpportunityId)
      )
        filterTotal = filterTotal + 1;
      if (
        thingToDo.organizationName &&
        _.includes(filters.recipient, thingToDo.organizationName)
      )
        filterTotal = filterTotal + 1;
      if (
        thingToDo.subOrganizationName &&
        _.includes(filters.subRecipient, thingToDo.subOrganizationName)
      )
        filterTotal = filterTotal + 1;
      if (
        thingToDo.disasterInfo &&
        _.includes(filters.disasterType, thingToDo.disasterInfo)
      )
        filterTotal = filterTotal + 1;
      if (thingToDo.status && filters.status === thingToDo.status)
        filterTotal = filterTotal + 1;
      if (
        thingToDo.dueDate &&
        formatDateMMDDYYYY(filters.dueDate) ===
          ISOToDisplayDate(thingToDo.dueDate, {
            showDate: true,
          })
      )
        filterTotal = filterTotal + 1;

      if (filterTotal > 0 && filterTotal === filterTarget) {
        filteredThings.push(thingToDo);
      }
    });
  }

  const NEW_GRANT_ROLE_PERMISSIONS = [
    ROLE_MAP.ORGAOR.code,
    ROLE_MAP.ORGMEMBER.code,
    ROLE_MAP.ORGPGMMEMBER.code,
    ROLE_MAP.ORGGRNTWRITER.code,
    ROLE_MAP.ORGFINMEMBER.code,
  ];

  const NEW_SUB_RECPT_PERMISSIONS = [ROLE_MAP.SUBAUTHREP.code, ROLE_MAP.SUBMEMBER.code];

  let permObj = _.reduce(
    props.permissions,
    (result, permission) => {
      const [entityTypeId, , roleId] = permission.split(':');
      if (_.indexOf(result.types, entityTypeId) === -1) {
        result.entityTypes.push(entityTypeId);
      }
      if (_.indexOf(result.roles, roleId) === -1) {
        result.roles.push(roleId);
      }
      return result;
    },
    {entityTypes: [], roles: []}
  );

  const isOnlySubRecipient =
    _.intersection(NEW_GRANT_ROLE_PERMISSIONS, permObj.roles).length == 0 &&
    _.intersection(NEW_SUB_RECPT_PERMISSIONS, permObj.roles).length > 0;

  return (
    <Grid.Column width={12}>
      {filteredThings && filteredThings.length > 0 ? (
        <ThingsToDoResults
          key="thingsToDoFilterResults"
          thingsToDo={filteredThings}
          isOnlySubRecipient={isOnlySubRecipient}
          setRedirect={setRedirect}
          props={props}
        />
      ) : !loading && filteredThings && filteredThings.length === 0 ? (
        <Alert header="Nothing to do" type="info">
          <p>There are No Things to do with your organization.</p>
        </Alert>
      ) : (
        // Added a second load to prevent a blank screen from appearing while page reloads.
        <Grid.Column width={12}>
          <Loader inline="centered" active content="Loading" />
        </Grid.Column>
      )}
    </Grid.Column>
  );
};

export default ThingsToDoCards;
